<template>
  <div class="tabs-widget">
    <div class="tab-item" :class="{ active: activeTab == 'overview' }" @click="switchTab('overview')">
      OVERVIEW
    </div>
    <div v-if="$checkPermission('video_storage')" class="h-spacer"></div>
    <div v-if="$checkPermission('video_storage')" class="tab-item" :class="{ active: activeTab == 'subcription' }"
      @click="switchTab('subcription')">
      SUBCRIPTIONS
    </div>
    <div v-if="$checkPermission('event_streaming')" class="h-spacer"></div>
    <div v-if="$checkPermission('event_streaming')" class="tab-item" :class="{ active: activeTab == 'streamed' }"
      @click="switchTab('streamed')">STREAMED</div>
    <div v-if="$checkPermission('voting')" class="h-spacer"></div>
    <div v-if="$checkPermission('voting')" class="tab-item" :class="{ active: activeTab == 'voting' }"
      @click="switchTab('voting')">VOTING</div>
    <div v-if="$checkPermission('events')" class="h-spacer"></div>
    <div v-if="$checkPermission('events')" class="tab-item" :class="{ active: activeTab == 'e-ticket' }"
      @click="switchTab('e-ticket')">EVENTS</div>
    <div v-if="$checkPermission('donation')" class="h-spacer"></div>
    <div v-if="$checkPermission('donation')" class="tab-item" :class="{ active: activeTab == 'donation' }"
      @click="switchTab('donation')">DONATIONS</div>
  </div>
</template>

<script>
export default {
  components: {},
  sockets: {},
  props: {
    activeTab: {
      type: String,
      default: "",
    },
  },
  data: () => ({}),
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("selected", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-widget {
  display: flex;
  align-items: flex-end;
  margin-right: 15px;
  flex-shrink: 0;

  @media (max-width: 638px) {
    margin-right: 0;

    .h-spacer {
      margin-right: 12px;
    }

    .tab-item {
      padding: 10px 4px;
      font-size: 12px;
    }
  }

  .h-spacer {
    margin-right: 20px;
  }

  .tab-item {
    cursor: pointer;
    padding: 14px 4px;
    border-bottom: 3px solid transparent;
    white-space: nowrap;

    &.active {
      color: var(--wecodefy-secondary-color, #9fc953);
      border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
    }
  }
}
</style>